import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';
import TextInput from '../../../lib/ui/form_elements/TextInput';

class SearchWithFilter extends PureComponent {
  getSearchResults = (e) => {
    const searchKey = e.target.value;
    this.props.getSuggestions(searchKey);
  };

  render() {
    return (
      <Field
        name="searchByKey"
        type="search"
        className={this.props.className}
        component={TextInput}
        label={this.props.label}
        onChange={this.getSearchResults}
      />
    );
  }
}

SearchWithFilter.propTypes = {
  getSuggestions: PropTypes.func,
  className: PropTypes.string,
  label: PropTypes.string,
};

export default SearchWithFilter;
